import {
  GET_PREVIOUS_RESALE_ENQUIRY_MFA,
  GET_PREVIOUS_RESALE_ENQUIRY_NON_MFA,
  GET_RESALE_ITEM_DETAILS_DATA_MFA,
  GET_RESALE_ITEM_DETAILS_DATA_NON_MFA,
  GET_RESALE_LIST_DATA_MFA,
  GET_RESALE_LIST_DATA_NON_MFA,
  SET_DATA_FOR_RESALE_ASSETS,
  SET_PREVIOUS_RESALE_ENQUIRY,
  SET_RESALE_ASSET_DETAILS_LOADING,
  SET_RESALE_ENQUIRY_SUBMITTING,
  SET_RESALE_ITEM_DETAILS_DATA,
  SET_RESALE_LOADING,
  SUBMIT_MFA_RESALE_ENQUIRY,
  SUBMIT_NON_MFA_RESALE_ENQUIRY,
} from './resale.actionTypes';
import {getCustomerId} from './resale.helper';
import {
  getPreviousResaleEnquiryServiceMfa,
  getPreviousResaleEnquiryServiceNonMfa,
  loadAssetDetailsForResaleTractorServiceMfa,
  loadAssetDetailsForResaleTractorServiceNonMfa,
  loadResaleTractorDataForMfaService,
  loadResaleTractorDataForNonMfaService,
  loadTranslations,
  submitResaleAssetEnquiryMfa,
  submitResaleAssetEnquiryNonMfa,
} from './resale.service';

import {logPageActionToNewRelic, PAGE_ACTION} from '../../utils/util';
import {manageAlert} from '../saga/offers.effects';

import {takeEvery, put, select, call} from 'redux-saga/effects';

export function* loadDataForMFAResaleTractor() {
  let resaleDataLoading = true;
  yield put({type: SET_RESALE_LOADING, resaleDataLoading});
  const stateCode = sessionStorage.getItem('offer_state_code');
  const customerId = yield select(getCustomerId);
  let response = yield loadResaleTractorDataForMfaService(
    customerId,
    stateCode
  );
  let sessionStorageList = sessionStorage.getItem('submittedAssetList');
  if (sessionStorageList) {
    let assetIdList = JSON.parse(sessionStorageList);
    response = response.filter((asset) => !assetIdList.includes(asset.assetId));
  }

  yield put({
    type: SET_DATA_FOR_RESALE_ASSETS,
    data: response,
  });

  resaleDataLoading = false;
  yield put({type: SET_RESALE_LOADING, resaleDataLoading});
}

export function* loadDataForNonMFAResaleTractor() {
  let resaleDataLoading = true;
  yield put({type: SET_RESALE_LOADING, resaleDataLoading});
  const stateCode = sessionStorage.getItem('offer_state_code');
  let response = yield loadResaleTractorDataForNonMfaService(stateCode);
  let sessionStorageList = sessionStorage.getItem('submittedAssetList');
  if (sessionStorageList) {
    let assetIdList = JSON.parse(sessionStorageList);
    response = response.filter((asset) => !assetIdList.includes(asset.assetId));
  }
  yield put({
    type: SET_DATA_FOR_RESALE_ASSETS,
    data: response,
  });

  resaleDataLoading = false;
  yield put({type: SET_RESALE_LOADING, resaleDataLoading});
}

export function* loadAssetDetailsForResaleTractorNonMfa({assetId}) {
  let assetDetailsLoading = true;
  yield put({type: SET_RESALE_ASSET_DETAILS_LOADING, assetDetailsLoading});
  yield loadTranslations();
  const response = yield loadAssetDetailsForResaleTractorServiceNonMfa(assetId);
  if (response.length) {
    const id = response[0].assetId;
    const finalData = {};
    finalData[id] = response[0];
    yield put({
      type: SET_RESALE_ITEM_DETAILS_DATA,
      data: finalData,
    });
    assetDetailsLoading = false;
    yield put({type: SET_RESALE_ASSET_DETAILS_LOADING, assetDetailsLoading});
  } else {
    assetDetailsLoading = false;
    yield put({type: SET_RESALE_ASSET_DETAILS_LOADING, assetDetailsLoading});
  }
}

export function* loadAssetDetailsForResaleTractorMfa({assetId}) {
  let assetDetailsLoading = true;
  yield put({type: SET_RESALE_ASSET_DETAILS_LOADING, assetDetailsLoading});
  yield loadTranslations();
  const customerId = yield select(getCustomerId);
  const response = yield loadAssetDetailsForResaleTractorServiceMfa(
    customerId,
    assetId
  );
  if (response.length) {
    const id = response[0].assetId;
    const finalData = {};
    finalData[id] = response[0];
    yield put({
      type: SET_RESALE_ITEM_DETAILS_DATA,
      data: finalData,
    });
    assetDetailsLoading = false;
    yield put({type: SET_RESALE_ASSET_DETAILS_LOADING, assetDetailsLoading});
  } else {
    assetDetailsLoading = false;
    yield put({type: SET_RESALE_ASSET_DETAILS_LOADING, assetDetailsLoading});
  }
}
export function* submitMfaResaleEnquiry({assetId}) {
  let resaleEnquirySubmitting = {status: 'inProgress'};
  yield put({type: SET_RESALE_ENQUIRY_SUBMITTING, resaleEnquirySubmitting});
  const customerId = yield select(getCustomerId);

  const response = yield submitResaleAssetEnquiryMfa(customerId, assetId);
  logPageActionToNewRelic(PAGE_ACTION.RESALE_ITEM_ENQUIRY, {
    isNonMfa: 'MFA',
    assetId: assetId,
  });
  if (response.data == 'submitted') {
    let assetIdList = sessionStorage.getItem('submittedAssetList');
    assetIdList = assetIdList ? JSON.parse(assetIdList) : [];
    assetIdList.push(assetId);
    sessionStorage.setItem('submittedAssetList', JSON.stringify(assetIdList));
    resaleEnquirySubmitting = {status: 'success', assetId};
    yield put({type: SET_RESALE_ENQUIRY_SUBMITTING, resaleEnquirySubmitting});
    yield call(manageAlert, {
      alertVariant: 'success',
      type: 'submitSuccess',
    });
  } else {
    if (response.data === 'REQUEST_ALREADY_SUBMIT') {
      let assetIdList = sessionStorage.getItem('submittedAssetList');
      assetIdList = assetIdList ? JSON.parse(assetIdList) : [];
      if (!assetIdList.includes(assetId)) {
        assetIdList.push(assetId);
        sessionStorage.setItem(
          'submittedAssetList',
          JSON.stringify(assetIdList)
        );
      }
      yield call(manageAlert, {
        alertVariant: 'warning',
        type: 'submitFailAlreadySubmitted',
      });
    } else {
      yield call(manageAlert, {
        alertVariant: 'danger',
        type: 'somethingWentWrong',
      });
    }
    resaleEnquirySubmitting = {status: 'success', assetId};
    yield put({type: SET_RESALE_ENQUIRY_SUBMITTING, resaleEnquirySubmitting});
  }
}

export function* submitNonMfaResaleEnquiry({enquiryData}) {
  let resaleEnquirySubmitting = {status: 'inProgress'};
  yield put({type: SET_RESALE_ENQUIRY_SUBMITTING, resaleEnquirySubmitting});
  delete enquiryData.phoneNumber;
  const response = yield submitResaleAssetEnquiryNonMfa(enquiryData);
  logPageActionToNewRelic(PAGE_ACTION.RESALE_ITEM_ENQUIRY, {
    isNonMfa: 'NON-MFA',
    assetId: enquiryData.assetId,
  });
  if (response.data == 'submitted') {
    let assetIdList = sessionStorage.getItem('submittedAssetList');
    if (!assetIdList) {
      assetIdList = [];
    } else {
      assetIdList = JSON.parse(assetIdList);
    }
    const enquiredAssetId = enquiryData.assetId;
    assetIdList.push(enquiredAssetId);
    sessionStorage.setItem('submittedAssetList', JSON.stringify(assetIdList));
    resaleEnquirySubmitting = {status: 'success', enquiredAssetId};
    yield put({type: SET_RESALE_ENQUIRY_SUBMITTING, resaleEnquirySubmitting});
    yield call(manageAlert, {
      alertVariant: 'success',
      type: 'submitSuccess',
    });
  } else {
    resaleEnquirySubmitting = {status: 'success'};
    yield put({type: SET_RESALE_ENQUIRY_SUBMITTING, resaleEnquirySubmitting});
    if (response.data === 'REQUEST_ALREADY_SUBMIT') {
      let assetIdList = sessionStorage.getItem('submittedAssetList');
      if (!assetIdList) {
        assetIdList = [];
      } else {
        assetIdList = JSON.parse(assetIdList);
      }
      assetIdList.push(enquiryData.assetId);
      sessionStorage.setItem('submittedAssetList', JSON.stringify(assetIdList));
      yield call(manageAlert, {
        alertVariant: 'danger',
        type: 'submitFailAlreadySubmitted',
      });
    } else {
      yield call(manageAlert, {
        alertVariant: 'danger',
        type: 'somethingWentWrong',
      });
    }
  }
}

export function* getPreviousResaleEnquiryForNonMfa() {
  let assetDetailsLoading = true;
  yield put({type: SET_RESALE_ASSET_DETAILS_LOADING, assetDetailsLoading});
  const response = yield getPreviousResaleEnquiryServiceNonMfa();

  yield put({
    type: SET_PREVIOUS_RESALE_ENQUIRY,
    data: response,
  });
  assetDetailsLoading = false;
  yield put({type: SET_RESALE_ASSET_DETAILS_LOADING, assetDetailsLoading});
}

export function* getPreviousResaleEnquiryForMfa() {
  let assetDetailsLoading = true;
  yield put({type: SET_RESALE_ASSET_DETAILS_LOADING, assetDetailsLoading});
  const customerId = yield select(getCustomerId);
  const response = yield getPreviousResaleEnquiryServiceMfa(customerId);

  yield put({
    type: SET_PREVIOUS_RESALE_ENQUIRY,
    data: response,
  });
  assetDetailsLoading = false;
  yield put({type: SET_RESALE_ASSET_DETAILS_LOADING, assetDetailsLoading});
}

export function* resaleWatcher() {
  yield takeEvery(GET_RESALE_LIST_DATA_MFA, loadDataForMFAResaleTractor);
  yield takeEvery(GET_RESALE_LIST_DATA_NON_MFA, loadDataForNonMFAResaleTractor);
  yield takeEvery(
    GET_RESALE_ITEM_DETAILS_DATA_MFA,
    loadAssetDetailsForResaleTractorMfa
  );
  yield takeEvery(
    GET_RESALE_ITEM_DETAILS_DATA_NON_MFA,
    loadAssetDetailsForResaleTractorNonMfa
  );
  yield takeEvery(SUBMIT_MFA_RESALE_ENQUIRY, submitMfaResaleEnquiry);
  yield takeEvery(SUBMIT_NON_MFA_RESALE_ENQUIRY, submitNonMfaResaleEnquiry);
  yield takeEvery(
    GET_PREVIOUS_RESALE_ENQUIRY_MFA,
    getPreviousResaleEnquiryForMfa
  );
  yield takeEvery(
    GET_PREVIOUS_RESALE_ENQUIRY_NON_MFA,
    getPreviousResaleEnquiryForNonMfa
  );
}
